module.exports = __webpack_public_path__ + "img/promo-code.3cde7009.svg";